/*
 * @Author: huasheng-c 957461792@qq.com
 * @Date: 2024-12-21 14:07:21
 * @LastEditors: huasheng-c 957461792@qq.com
 * @LastEditTime: 2024-12-21 17:03:49
 * @FilePath: \IOT4CMS\src\layouts\baseLayout\projectSelect\components\ProjectSelectStyle\index.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import React, { FC } from 'react'

import { GlobalModelState } from '@/models/connect'
import { connect, Loading } from 'umi'

import { Image } from 'antd'
import './index.less'

const ProjectSelectStyle = props => {
	const { text, image, tips, onTap } = props
	return (
		<div className="ProjectSelectStyle-container">
			<div className="imageStyle" onClick={onTap}>
				<Image width="100%" height="100%" src={image} preview={false} />
				{tips && <div className="imageStyle-tips">{tips}</div>}
			</div>

			<div className="text">{text}</div>
		</div>
	)
}

export default ProjectSelectStyle
